import {Map} from 'immutable';

import * as Join from '../../actions/auth/Join';
import * as FastJoin from '../../actions/auth/FastJoin';
import * as PhoneConfirm from '../../actions/PhoneConfirmation';
import * as AuthActions from 'actions/Auth';

import * as JoinStage from 'constants/JoinStage';
import * as JoinType from 'constants/JoinType';

const initialState = Map({
    type: JoinType.FAST,
    stage: JoinStage.NONE,
    inProcess: false,
    error: null,
    userRegistration: undefined,
    fastJoin: undefined
});

export default function join(state = initialState, action = {}) {
    switch (action.type) {
        case PhoneConfirm.CREATE_PHONE_CONFIRMATION:
        case PhoneConfirm.FAILURE_CREATE_PHONE_CONFIRMATION:
        case PhoneConfirm.CONFIRM_PHONE:
        case PhoneConfirm.SUCCESS_CONFIRM_PHONE:
        case PhoneConfirm.FAILURE_CONFIRM_PHONE:
            state = state.set('stage', JoinStage.PHONE_CONFIRMATION);
            break;

        case PhoneConfirm.SUCCESS_CREATE_PHONE_CONFIRMATION:
            state = state.set('stage', JoinStage.PHONE_CONFIRMATION);
            if (action.data.Phone) {
                state = state.setIn(['userRegistration', 'phone'], action.data.Phone);
            }
            break;

        case PhoneConfirm.DENY_CONFIRMATION:
            state = state.set('stage', JoinStage.SUCCESS);
            break;

        case '@@router/LOCATION_CHANGE':
            if (action.payload.pathname === '/' && action.payload.hash === '#join') {
                state = state.set('stage', JoinStage.INIT);
            }/*  else {
                state = state.set('stage', JoinStage.NONE);
            } */
            break;

        case AuthActions.BEGIN_SIGNIN:
            state = state.set('stage', JoinStage.NONE);
            break;

        case AuthActions.BEGIN_JOIN:
            state = state.set('type', JoinType.FAST);
            state = state.set('stage', JoinStage.INIT);
            break;

        case Join.CHANGE_JOIN_TYPE: {
            const newJoinType = action.data.joinType;

            state = state.set('type', newJoinType);
            state = state.set('stage', JoinStage.INIT);
            state = state.set('error', null);
            if (newJoinType === JoinType.FAST) {
                state = state.set('userRegistration', undefined);
            } else if (newJoinType === JoinType.REGULAR) {
                state = state.set('fastJoin', undefined);
            }
            break;
        }

        case Join.JOIN:
            state = state.set('error', null);
            state = state.set('inProcess', true);
            break;

        case Join.SUCCESS_JOIN:
            state = state.set('inProcess', false);
            if (action.data.Error) {
                state = state.set('error', action.data.Error);
                state = action.data.PromocodeError ? state.set('PromocodeError', action.data.PromocodeError) : state.set('PromocodeError', null);
            } else {
                const phoneConfirmationNeeded = action.data.PhoneConfirmation;

                const userRegistration = Map({
                    phone: action.data.Phone,
                    phoneConfirmationNeeded,
                    gamblerId: action.data.UserId,
                    email: action.data.Email,
                    joinPromoType: action.data.JoinPromoType
                });

                state = state.set('error', null);
                state = state.set('userRegistration', userRegistration);

                if (phoneConfirmationNeeded === true) {
                    state = state.set('stage', JoinStage.PHONE_CONFIRMATION);
                } else {
                    state = state.set('stage', JoinStage.SUCCESS);
                }
            }
            break;

        case FastJoin.FAST_JOIN:
            state = state.set('fastJoin', Map(action.data));
            state = state.set('error', null);
            state = state.set('inProcess', true);
            break;

        case FastJoin.SUCCESS_FAST_JOIN:
            state = state.set('inProcess', false);
            if (action.data.Error) {
                state = state.set('error', action.data.Error);
                state = action.data.PromocodeError ? state.set('PromocodeError', action.data.PromocodeError) : state.set('PromocodeError', null);
            } else if (action.data.RequestId !== undefined && action.data.RequestId !== null) {
                const requestId = action.data.RequestId;

                state = state.set('error', null);
                state = state.setIn(['fastJoin', 'RequestId'], requestId);
                state = state.set('stage', JoinStage.PHONE_CONFIRMATION);
            } else if (action.data.Email) {
                state = state.set('error', null);
                state = state.setIn(['fastJoin', 'Email'], action.data.Email);
                state = state.set('stage', JoinStage.EMAIL_SENT);
            }
            break;

        case FastJoin.FAILURE_FAST_JOIN:
            state = state.set('inProcess', false);
            state = state.set('error', -100);
            break;

        case FastJoin.FAST_CONFIRM_PHONE:
            state = state.set('inProcess', true);
            state = state.set('error', null);
            break;

        case FastJoin.SUCCESS_FAST_CONFIRM_PHONE:
            state = state.set('inProcess', false);
            if (action.data.hasOwnProperty('Error')) {
                state = state.set('error', action.data.Error);
            } else {
                state = state.set('error', null);
                state = state.set('fastJoin', undefined);
                state = state.set('stage', JoinStage.SUCCESS);
            }
            break;

        case FastJoin.FAILURE_FAST_CONFIRM_PHONE:
            state = state.set('inProcess', false);
            state = state.set('error', -100);
            break;

        case AuthActions.CANCEL_JOIN:
            state = state.set('stage', JoinStage.NONE);
            state = state.set('error', null);
            state = state.set('inProcess', false);
            state = state.set('userRegistration', undefined);
            state = state.set('fastJoin', undefined);
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/joinReducer.js